module.exports = __webpack_public_path__ + "img/tablet.98e1d272.svg";